import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type Query = {
  __typename?: 'Query';
  getServiceUser?: Maybe<ServiceUserDetail>;
};

export type ServiceUserDetail = {
  __typename?: 'ServiceUserDetail';
  email?: Maybe<Scalars['String']['output']>;
  hasTrustReferral: Scalars['Boolean']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type GetServiceUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetServiceUserQuery = { __typename?: 'Query', getServiceUser?: { __typename?: 'ServiceUserDetail', email?: string | null, phoneNumber?: string | null, username: string, hasTrustReferral: boolean } | null };


export const GetServiceUserDocument = gql`
    query getServiceUser {
  getServiceUser {
    email
    phoneNumber
    username
    hasTrustReferral
  }
}
    `;

export function useGetServiceUserQuery(options?: Omit<Urql.UseQueryArgs<GetServiceUserQueryVariables>, 'query'>) {
  return Urql.useQuery<GetServiceUserQuery, GetServiceUserQueryVariables>({ query: GetServiceUserDocument, ...options });
};